// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Inter.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    box-sizing: border-box;
}

@font-face {
    font-family: "Inter";
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("ttf");
}

@keyframes hit-pulse {
    0% {
        transform: translate(-50%, -50%) scale(1);
    }

    50% {
        transform: translate(-50%, -50%) scale(1.3);
    }

    100% {
        transform: translate(-50%, -50%) scale(1);
    }
}

@keyframes hit-ring {
    0% {
        transform: scale(1);
        opacity: 0.6;
    }

    100% {
        transform: scale(3);
        opacity: 0;
    }
}

@keyframes miss-ripple {
    0% {
        transform: scale(1);
        opacity: 0.6;
    }

    100% {
        transform: scale(3);
        opacity: 0;
    }
}

@keyframes shake {
    0% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-4px);
    }

    50% {
        transform: translateX(4px);
    }

    75% {
        transform: translateX(-2px);
    }

    100% {
        transform: translateX(0);
    }
}

@keyframes invalid-flash {
    0% {
        background: rgba(224, 78, 78, 0.4);
    }

    100% {
        background: rgba(224, 78, 78, 0);
    }
}

@keyframes waitingFade {
    0% {
        opacity: 0.8;
        scale: 1;
    }

    50% {
        opacity: 1.6;
        scale: 1.1;
    }

    100% {
        opacity: 0.8;
        scale: 1;
    }
}

@keyframes dialogIn {
    0% {
        opacity: 0;
        transform: scale(0.96);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }
}

.dialog-enter {
    animation: dialogIn 140ms ease-out;
}

.waiting {
    animation: waitingFade 1.8s ease-in-out infinite;
}

p,
h1,
h3,
h4,
body {
    margin: 0;
}

body {
    font-family: 'Inter';
    height: 100dvh;
    background-image: linear-gradient(to bottom, #12394A, #07141C);

    display: flex;
    flex-direction: column;

    text-align: center;
}

main {
    display: flex;

    flex: 1;

    align-items: center;
    justify-content: center;
}

.start-screen {
    padding: 80px 120px;

    display: flex;
    flex-direction: column;

    gap: 40px;

    margin-bottom: 60px;
}

.game-title {
    font-size: 32px;
    font-weight: 600;
    color: #E6F2F7;
}

.battle-select {
    display: flex;
    gap: 64px;
}

.card {
    height: 170px;
    width: 320px;
    background-color: #0F2A38;
    border: 1px solid #1F4E63;
    border-radius: 12px;

    display: flex;
    flex-direction: column;

    justify-content: center;
    align-items: center;

    padding: 20px;

    gap: 8px;
}

.card:has(.bottom-card.inactive):hover {
    border: 1px solid #3FA7C4;
    box-shadow: 0 0 12px rgba(63, 167, 196, 0.25);
    scale: 1.03;
}

.card:has(.bottom-card.inactive) {
    scale: 1;
}

.card:has(.bottom-card) {
    scale: 1.05;
}

.card:has(.bottom-card:not(.inactive)) {
    height: 240px;
    border: 1px solid #3FA7C4;
    box-shadow: 0 0 16px rgba(63, 167, 196, 0.2);
}

.select-title {
    font-size: 18px;
    font-weight: 600;
    color: #E6F2F7;
}

.select-subtitle {
    font-size: 14px;
    color: #9BB7C4;
}

input {
    height: 40px;
    width: 100%;

    background: #0F2A38;
    border: 1px solid #1F4E63;
    border-radius: 8px;
    color: #E6F2F7;

    font-size: 14px;
    font-weight: 400;
    padding: 0 12px;

    margin-top: 6px;
}

input::placeholder {
    color: #A8C0CC;
}

input:focus {
    outline: none;
    border-color: #3FA7C4;
    box-shadow: 0 0 8px rgba(63, 167, 196, 0.25);
}

input:hover {
    outline: none;
    border-color: #2A6F89;
}

.input-subtext {
    font-size: 12px;
    color: #9BB7C4;
}

.start-game-btn {
    height: 40px;
    width: 100%;

    border-radius: 8px;
    background-color: #174B5F;
    border: 1px solid #1F4E63;
    color: #E6F2F7;

    font-size: 14px;
    font-weight: 600;

    margin: 16px 0 12px 0;
}

.start-game-btn:hover {
    background-color: #174B5F;
    border-color: #3FA7C4;
}

.boards-screen {
    display: flex;
    justify-content: center;
    align-items: flex-start;

    gap: 80px;
}

.board-wrapper {
    position: relative;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: 12px;
}

.board {
    display: grid;
    grid-template-columns: repeat(11, 48px);
    grid-template-rows: repeat(11, 48px);
}

.board-cell {
    border-right: 1px solid #2a6f89b3;
    border-bottom: 1px solid #2a6f89b3;

    display: flex;
    align-items: center;
    justify-content: center;

    position: relative;
}

.board-cell:has([class*='horizontal']) {
    flex-direction: column;
}

.board-cell[data-col='0'] {
    border-left: 1px solid #1F4E63;
}

.board-cell[data-col='9'] {
    border-right: 1px solid #1F4E63;
}

.board-cell[data-row='9'] {
    border-bottom: 1px solid #1F4E63;
}

.board-cell[data-row='0'] {
    border-top: 1px solid #1F4E63;
}

.board-cell.no-border {
    border: none;
    align-self: center;
}

.board-label {
    color: #7FA9B8;
    font-size: 14px;
    font-weight: 500;
}

.board-title {
    font-size: 18px;
    font-weight: 600;
    color: #E6F2F7;
}

.ship-piece-sunk {
    background-color: #2F3A40;
    opacity: 70%;
}

.ship-piece,
.ship-piece-sunk {
    width: 48px;
    height: 48px;
    background-color: #4A6873;
}

.ship-piece-start-horizontal,
.ship-piece-sunk-start-horizontal {
    border-radius: 50% 0 0 50%;
    height: 38px;
    margin-left: 8px;
    width: 40px;

    border-top: 1px solid rgba(255, 255, 255, 0.25);
    border-left: 1px solid rgba(255, 255, 255, 0.25);
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.ship-piece-sunk-start-horizontal {
    border-top: 2px solid #FF5A5A;
    border-left: 2px solid #FF5A5A;
    border-bottom: 2px solid #FF5A5A;
}

.ship-piece-middle-horizontal,
.ship-piece-sunk-middle-horizontal {
    height: 38px;
    width: 48px;

    border-top: 1px solid rgba(255, 255, 255, 0.25);
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.ship-piece-sunk-middle-horizontal {
    border-top: 2px solid #FF5A5A;
    border-bottom: 2px solid #FF5A5A;
}

.ship-piece-finish-horizontal,
.ship-piece-sunk-finish-horizontal {
    border-radius: 0 50% 50% 0;
    height: 38px;
    margin-right: 8px;
    width: 40px;

    border-top: 1px solid rgba(255, 255, 255, 0.25);
    border-right: 1px solid rgba(255, 255, 255, 0.25);
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.ship-piece-sunk-finish-horizontal {
    border-top: 2px solid #FF5A5A;
    border-right: 2px solid #FF5A5A;
    border-bottom: 2px solid #FF5A5A;
}

.ship-piece-start-vertical,
.ship-piece-sunk-start-vertical {
    border-radius: 50% 50% 0 0;
    width: 38px;
    margin-top: 8px;
    height: 40px;

    border-top: 1px solid rgba(255, 255, 255, 0.25);
    border-left: 1px solid rgba(255, 255, 255, 0.25);
    border-right: 1px solid rgba(255, 255, 255, 0.25);
}

.ship-piece-sunk-start-vertical {
    border-top: 2px solid #FF5A5A;
    border-left: 2px solid #FF5A5A;
    border-right: 2px solid #FF5A5A;
}

.ship-piece-middle-vertical,
.ship-piece-sunk-middle-vertical {
    width: 38px;

    border-left: 1px solid rgba(255, 255, 255, 0.25);
    border-right: 1px solid rgba(255, 255, 255, 0.25);
}

.ship-piece-sunk-middle-vertical {
    border-left: 2px solid #FF5A5A;
    border-right: 2px solid #FF5A5A;
}

.ship-piece-finish-vertical,
.ship-piece-sunk-finish-vertical {
    border-radius: 0 0 50% 50%;
    width: 38px;
    margin-bottom: 8px;
    height: 40px;

    border-right: 1px solid rgba(255, 255, 255, 0.25);
    border-left: 1px solid rgba(255, 255, 255, 0.25);
    border-bottom: 1px solid rgba(255, 255, 255, 0.25);
}

.ship-piece-sunk-finish-vertical {
    border-bottom: 2px solid #FF5A5A;
    border-left: 2px solid #FF5A5A;
    border-right: 2px solid #FF5A5A;
}

.ship-piece-single-none,
.ship-piece-sunk-single-none {
    width: 28px;
    height: 40px;
    margin: 8px 0;

    border: 1px solid rgba(255, 255, 255, 0.25);

    border-radius: 75% / 30%;
}

.ship-piece-sunk-single-none {
    border: 2px solid #FF5A5A;
}

.move-hit {
    position: absolute;

    width: 12px;
    height: 12px;
    background: #F05A5A;

    border-radius: 50%;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(1);

    animation: hit-pulse 0.2s ease;
}

.move-hit::after {
    content: '';
    position: absolute;

    inset: 0;
    border: 2px solid #FF6B6B;
    border-radius: 50%;

    animation: hit-ring 0.35s ease-out;
}

.move-miss {
    position: absolute;

    width: 8px;
    height: 8px;
    background: #D8F1FF;

    border-radius: 50%;

    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.move-miss::after {
    content: '';
    position: absolute;

    inset: 0;
    border: 2px solid #A6D8F0;
    border-radius: 50%;

    animation: miss-ripple 0.4s ease-out;
}

.name {
    font-weight: 500;
    font-size: 16px;
}

#user-name {
    color: #CFE4EC;
}

#comp-name {
    color: rgba(207, 228, 236, 0.7);
}

.active-turn {
    color: #4FC3E0;
}

.inactive-turn {
    color: rgba(207, 228, 236, 0.5);
}

.player-board-buttons-wrapper {
    display: flex;

    gap: 12px;
}

#generate-ships-placement-btn {
    background-color: #349BB5;
    color: #FFFFFF;
    height: 40px;
    padding: 0 20px;
    border-radius: 8px;

    font-size: 14px;
    font-weight: 500;

    border: none;
}

#generate-ships-placement-btn:hover {
    background-color: #3FA7C4;
}

#drag-and-drop-ships-btn {
    background-color: transparent;
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #CFE4EC;
    height: 40px;
    padding: 0 20px;
    border-radius: 8px;
}

#drag-and-drop-ships-btn:hover {
    border-color: rgba(255, 255, 255, 0.35);
    background-color: rgba(255, 255, 255, 0.04);
}

.dialog {
    width: 420px;
    padding: 36px;
    background-color: #11323F;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 12px;

    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);
}

.winner-announcement-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.result {
    font-size: 26px;
    font-weight: 600;
    margin-bottom: 16px;
}

.result-subtext {
    font-size: 14px;
    color: rgba(207, 228, 236, 0.7);
    margin-bottom: 24px;
}

.result.victory {
    color: #5FD1EE;
}

.result.defeat {
    color: #E04E4E;
}

.announcement-buttons-wrapper {
    display: flex;
    gap: 20px;
    margin-top: 24px;
}

#play-again-btn {
    height: 40px;
    border-radius: 8px;
    background-color: #46B5CF;
    color: #FFFFFF;
    font-weight: 500;
    border: none;
    padding: 0 24px
}

#play-again-btn:hover {
    background-color: #4FC3E0;
}

#exit-btn {
    height: 40px;
    border-radius: 8px;
    background-color: transparent;
    border: 1px solid #4A8090;
    color: #CFE4EC;
    padding: 0 24px
}

#exit-btn:hover {
    background-color: rgba(255, 255, 255, 0.05);
}

.drag-and-drop-ships-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;

    gap: 16px;

    height: 120px;
}

.ship {
    scale: 0.8;
}

.ship[data-direction='horizontal'] {
    display: flex;
}

.ship[data-direction='vertical'] {
    display: flex;
    flex-direction: column;
}

.ship.inactive {
    display: none;
}

.invalid-shake {
    animation: shake 150ms ease;
}

.board-cell.invalid {
    background: rgba(224, 78, 78, 0.25);
    border: 1px solid #E04E4E;
    animation: invalid-flash 150ms ease;
}

.resize {
    height: auto;
}

.enabled {
    pointer-events: auto;
}

.disabled {
    pointer-events: none;
}

.is-player-ready {
    position: absolute;
    inset: 0;

    background: rgba(5, 20, 25, 0.4);
    backdrop-filter: blur(3px);
    border-radius: inherit;
    pointer-events: auto;

    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    top: 10%;
}

.is-player-ready-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;

    padding: 24px 26px;

    width: 280px;

    background-color: rgba(18, 52, 64, 0.96);
    border: 1px solid rgba(120, 200, 220, 0.22);
    border-radius: 10px;
    box-shadow: 0 10px 26px rgba(0, 0, 0, 0.35);
}

.is-player-ready-wrapper:hover {
    animation-play-state: paused;
}

#is-ready-title {
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 1px;
    color: #6FD3E3;
    text-align: center;
}

.is-ready-subtext {
    font-size: 13px;
    color: rgba(200, 230, 240, 0.7);
    line-height: 1.4;
    text-align: center;
}

.ready-subtext {
    font-size: 14px;
    color: rgba(220, 245, 255, 0.85);
}

#is-ready-button {
    margin-top: 4px;
    height: 38px;
    padding: 0 20px;
    font-size: 14px;
    font-weight: 600;

    background-color: #4FA3B8;
    color: #FFFFFF;

    border: none;
    border-radius: 8px;
}

#is-ready-button:hover {
    background-color: #569FB2;
    box-shadow: 0 3px 10px rgba(80, 180, 200, 0.18);
}

#connection-form-dialog {
    width: 460px;
    padding: 24px 28px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);

    opacity: 0;
    transform: translateY(12px);
    transition:
        opacity 180ms ease,
        transform 180ms ease;
}

#connection-form-dialog.open {
    opacity: 1;
    transform: translateY(0);
}

.connection-header {
    font-size: 20px;
    font-weight: 600;
    letter-spacing: 0.8px;
    color: #5FD1EE;
}

.connection-subtext {
    font-size: 14px;
    color: rgba(207, 228, 236, 0.7);
    line-height: 1.4;
}

.connection-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.host-player-top-wrapper,
.connection-top-wrapper,
.connect-to-friend-form-top-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    width: 100%;
}

.close-btn {
    position: absolute;
    right: 12px;
}

.connection-btns-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 24px;

    margin-top: 16px;
}

#start-connection-btn {
    height: 40px;
    padding: 0 28px;
    background-color: #46B5CF;
    color: #E6F2F7;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;

    white-space: nowrap;
}

#start-connection-btn:hover {
    background-color: #4FC3E0;
}

#connect-to-friend-btn {
    height: 40px;
    padding: 0 28px;
    background-color: transparent;
    color: #CFE4EC;
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;

    white-space: nowrap;
}

#connect-to-friend-btn:hover {
    background-color: rgba(120, 200, 220, 0.08);
    border: 1px solid rgba(120, 200, 220, 0.55);
    color: #E6FAFF;
}

#connection-to-friend-btn:hover {
    background-color: rgba(255, 255, 255, 0.05);
}

#copy-player-id-btn,
.close-btn {
    width: 32px;
    height: 32px;
    background-color: transparent;
    border: none;
}

#copy-img,
.img {
    width: 22px;
    height: 22px;
    filter: invert(89%) sepia(8%) saturate(323%) hue-rotate(169deg) brightness(95%) contrast(92%);
}

#copy-player-id-btn:hover,
.close-btn:hover {
    background-color: rgba(255, 255, 255, 0.08);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 6px;
}

.copy-player-id-wrapper {
    display: flex;
    gap: 6px;

    align-items: center;
    justify-content: center;
}

.host-player-id-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

#host-player-title,
.title {
    font-size: 20px;
    font-weight: 600;
    color: #5FD1EE;
    letter-spacing: 0.6px;
}

#host-player-subtext {
    font-size: 13px;
    color: rgba(207, 228, 236, 0.65);
    margin-bottom: 10px;
}

#host-player-id {
    font-size: 17px;
    color: #F2FAFF;
    letter-spacing: 0.7px;
    word-break: break-all;
    font-weight: 500;
}

.player-id-wrapper {
    padding: 12px 14px;
    background: rgba(0, 0, 0, 0.24);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 6px;
}

.copy-btn-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
}

#id-copied-confirmation-text {
    font-size: 12px;
    color: #5FD1EE;
}

.connect-to-friend-title {
    color: #6FD3E3;
}

#connect-friend-subtext {
    font-size: 13px;
    color: rgba(200, 230, 240, 0.7);
}

#friend-id {
    margin-top: 8px;
    text-align: center;
}

#set-connection-btn {
    height: 44px;
    padding: 0 26px;
    font-size: 14px;
    font-weight: 600;
    border-radius: 10px;
    background-color: #4FA3B8;
    color: #E6F2F7;
    border: none;
    box-shadow: 0 2px 8px rgba(80, 180, 200, 0.15);
    margin-top: 12px;
}

#set-connection-btn:hover {
    background-color: #569FB2;
    box-shadow: 0 4px 12px rgba(80, 180, 200, 0.18);
}

.connect-to-friend-form {
    display: flex;
    flex-direction: column;

    align-items: center;
    justify-content: center;

    gap: 14px;
}

.connection-closed-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: 14px;
}

#signal-lost-text {
    font-size: 18px;
    font-weight: 400;
    line-height: 1.5;
    color: rgba(220, 245, 255, 0.85);
    max-width: 360px;
    text-align: center;
}

#ok-button {
    height: 36px;
    min-width: 90px;
    padding: 0 18px;

    font-size: 14px;
    font-weight: 600;

    background-color: #4FA3B8;
    color: #FFFFFF;

    border: none;
    border-radius: 8px;
}

#ok-button:hover {
    background-color: #569FB2;
    box-shadow: 0 1px 4px rgba(80, 180, 200, 0.12);
}

#rematch-primary-line {
    font-size: 16px;
    font-weight: 500;
    color: rgba(220, 245, 255, 0.85);
    line-height: 1.4;
}

#rematch-secondary-line {
    font-size: 15px;
    font-weight: 400;
    color: rgba(220, 245, 255, 0.65);
    line-height: 1.4;
}

.play-again-text {
    color: #6FD3E3;
    font-weight: 600;
}

footer {
    padding: 24px 0;

    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.3px;
    color: rgba(255, 255, 255, 0.65);
}

.inactive {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;IACpB,0DAA2C;AAC/C;;AAEA;IACI;QACI,yCAAyC;IAC7C;;IAEA;QACI,2CAA2C;IAC/C;;IAEA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,mBAAmB;QACnB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,kCAAkC;IACtC;;IAEA;QACI,gCAAgC;IACpC;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,QAAQ;IACZ;AACJ;;AAEA;IACI;QACI,UAAU;QACV,sBAAsB;IAC1B;;IAEA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gDAAgD;AACpD;;AAEA;;;;;IAKI,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,cAAc;IACd,8DAA8D;;IAE9D,aAAa;IACb,sBAAsB;;IAEtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;;IAEb,OAAO;;IAEP,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;;IAEnB,aAAa;IACb,sBAAsB;;IAEtB,SAAS;;IAET,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;;IAEnB,aAAa;IACb,sBAAsB;;IAEtB,uBAAuB;IACvB,mBAAmB;;IAEnB,aAAa;;IAEb,QAAQ;AACZ;;AAEA;IACI,yBAAyB;IACzB,6CAA6C;IAC7C,WAAW;AACf;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,4CAA4C;AAChD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;;IAEX,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;;IAEd,eAAe;IACf,gBAAgB;IAChB,eAAe;;IAEf,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,WAAW;;IAEX,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;;IAEd,eAAe;IACf,gBAAgB;;IAEhB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,uBAAuB;;IAEvB,SAAS;AACb;;AAEA;IACI,kBAAkB;;IAElB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;IAEvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uCAAuC;IACvC,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;IACjC,kCAAkC;;IAElC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;;IAEI,0BAA0B;IAC1B,YAAY;IACZ,gBAAgB;IAChB,WAAW;;IAEX,+CAA+C;IAC/C,gDAAgD;IAChD,kDAAkD;AACtD;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;;IAEI,YAAY;IACZ,WAAW;;IAEX,+CAA+C;IAC/C,kDAAkD;AACtD;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;;IAEI,0BAA0B;IAC1B,YAAY;IACZ,iBAAiB;IACjB,WAAW;;IAEX,+CAA+C;IAC/C,iDAAiD;IACjD,kDAAkD;AACtD;;AAEA;IACI,6BAA6B;IAC7B,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;;IAEI,0BAA0B;IAC1B,WAAW;IACX,eAAe;IACf,YAAY;;IAEZ,+CAA+C;IAC/C,gDAAgD;IAChD,iDAAiD;AACrD;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;IAEI,WAAW;;IAEX,gDAAgD;IAChD,iDAAiD;AACrD;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;IAEI,0BAA0B;IAC1B,WAAW;IACX,kBAAkB;IAClB,YAAY;;IAEZ,iDAAiD;IACjD,gDAAgD;IAChD,kDAAkD;AACtD;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;IAC9B,+BAA+B;AACnC;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,aAAa;;IAEb,2CAA2C;;IAE3C,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;;IAElB,WAAW;IACX,YAAY;IACZ,mBAAmB;;IAEnB,kBAAkB;;IAElB,QAAQ;IACR,SAAS;IACT,yCAAyC;;IAEzC,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,kBAAkB;;IAElB,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;;IAElB,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;;IAElB,UAAU;IACV,WAAW;IACX,mBAAmB;;IAEnB,kBAAkB;;IAElB,QAAQ;IACR,SAAS;IACT,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,kBAAkB;;IAElB,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;;IAElB,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,aAAa;;IAEb,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,kBAAkB;;IAElB,eAAe;IACf,gBAAgB;;IAEhB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,0CAA0C;IAC1C,cAAc;IACd,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,uCAAuC;IACvC,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,2CAA2C;IAC3C,mBAAmB;;IAEnB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;IACd;AACJ;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;IAEvB,SAAS;;IAET,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;;IAER,gCAAgC;IAChC,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;;IAEpB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;IAEvB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;IAET,kBAAkB;;IAElB,YAAY;;IAEZ,wCAAwC;IACxC,2CAA2C;IAC3C,mBAAmB;IACnB,2CAA2C;AAC/C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;;IAEhB,yBAAyB;IACzB,cAAc;;IAEd,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;;IAE3C,UAAU;IACV,2BAA2B;IAC3B;;4BAEwB;AAC5B;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;;;IAGI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;IAElB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;;IAET,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;;IAEhB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,6BAA6B;IAC7B,cAAc;IACd,0CAA0C;IAC1C,kBAAkB;IAClB,eAAe;IACf,gBAAgB;;IAEhB,mBAAmB;AACvB;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,cAAc;AAClB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,YAAY;IACZ,6FAA6F;AACjG;;AAEA;;IAEI,2CAA2C;IAC3C,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;;IAER,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,2CAA2C;IAC3C,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,8CAA8C;IAC9C,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,+CAA+C;AACnD;;AAEA;IACI,aAAa;IACb,sBAAsB;;IAEtB,mBAAmB;IACnB,uBAAuB;;IAEvB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;IAEvB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,eAAe;;IAEf,eAAe;IACf,gBAAgB;;IAEhB,yBAAyB;IACzB,cAAc;;IAEd,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;;IAEf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,aAAa;AACjB","sourcesContent":["* {\n    box-sizing: border-box;\n}\n\n@font-face {\n    font-family: \"Inter\";\n    src: url(\"./fonts/Inter.ttf\") format(\"ttf\");\n}\n\n@keyframes hit-pulse {\n    0% {\n        transform: translate(-50%, -50%) scale(1);\n    }\n\n    50% {\n        transform: translate(-50%, -50%) scale(1.3);\n    }\n\n    100% {\n        transform: translate(-50%, -50%) scale(1);\n    }\n}\n\n@keyframes hit-ring {\n    0% {\n        transform: scale(1);\n        opacity: 0.6;\n    }\n\n    100% {\n        transform: scale(3);\n        opacity: 0;\n    }\n}\n\n@keyframes miss-ripple {\n    0% {\n        transform: scale(1);\n        opacity: 0.6;\n    }\n\n    100% {\n        transform: scale(3);\n        opacity: 0;\n    }\n}\n\n@keyframes shake {\n    0% {\n        transform: translateX(0);\n    }\n\n    25% {\n        transform: translateX(-4px);\n    }\n\n    50% {\n        transform: translateX(4px);\n    }\n\n    75% {\n        transform: translateX(-2px);\n    }\n\n    100% {\n        transform: translateX(0);\n    }\n}\n\n@keyframes invalid-flash {\n    0% {\n        background: rgba(224, 78, 78, 0.4);\n    }\n\n    100% {\n        background: rgba(224, 78, 78, 0);\n    }\n}\n\n@keyframes waitingFade {\n    0% {\n        opacity: 0.8;\n        scale: 1;\n    }\n\n    50% {\n        opacity: 1.6;\n        scale: 1.1;\n    }\n\n    100% {\n        opacity: 0.8;\n        scale: 1;\n    }\n}\n\n@keyframes dialogIn {\n    0% {\n        opacity: 0;\n        transform: scale(0.96);\n    }\n\n    100% {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n.dialog-enter {\n    animation: dialogIn 140ms ease-out;\n}\n\n.waiting {\n    animation: waitingFade 1.8s ease-in-out infinite;\n}\n\np,\nh1,\nh3,\nh4,\nbody {\n    margin: 0;\n}\n\nbody {\n    font-family: 'Inter';\n    height: 100dvh;\n    background-image: linear-gradient(to bottom, #12394A, #07141C);\n\n    display: flex;\n    flex-direction: column;\n\n    text-align: center;\n}\n\nmain {\n    display: flex;\n\n    flex: 1;\n\n    align-items: center;\n    justify-content: center;\n}\n\n.start-screen {\n    padding: 80px 120px;\n\n    display: flex;\n    flex-direction: column;\n\n    gap: 40px;\n\n    margin-bottom: 60px;\n}\n\n.game-title {\n    font-size: 32px;\n    font-weight: 600;\n    color: #E6F2F7;\n}\n\n.battle-select {\n    display: flex;\n    gap: 64px;\n}\n\n.card {\n    height: 170px;\n    width: 320px;\n    background-color: #0F2A38;\n    border: 1px solid #1F4E63;\n    border-radius: 12px;\n\n    display: flex;\n    flex-direction: column;\n\n    justify-content: center;\n    align-items: center;\n\n    padding: 20px;\n\n    gap: 8px;\n}\n\n.card:has(.bottom-card.inactive):hover {\n    border: 1px solid #3FA7C4;\n    box-shadow: 0 0 12px rgba(63, 167, 196, 0.25);\n    scale: 1.03;\n}\n\n.card:has(.bottom-card.inactive) {\n    scale: 1;\n}\n\n.card:has(.bottom-card) {\n    scale: 1.05;\n}\n\n.card:has(.bottom-card:not(.inactive)) {\n    height: 240px;\n    border: 1px solid #3FA7C4;\n    box-shadow: 0 0 16px rgba(63, 167, 196, 0.2);\n}\n\n.select-title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #E6F2F7;\n}\n\n.select-subtitle {\n    font-size: 14px;\n    color: #9BB7C4;\n}\n\ninput {\n    height: 40px;\n    width: 100%;\n\n    background: #0F2A38;\n    border: 1px solid #1F4E63;\n    border-radius: 8px;\n    color: #E6F2F7;\n\n    font-size: 14px;\n    font-weight: 400;\n    padding: 0 12px;\n\n    margin-top: 6px;\n}\n\ninput::placeholder {\n    color: #A8C0CC;\n}\n\ninput:focus {\n    outline: none;\n    border-color: #3FA7C4;\n    box-shadow: 0 0 8px rgba(63, 167, 196, 0.25);\n}\n\ninput:hover {\n    outline: none;\n    border-color: #2A6F89;\n}\n\n.input-subtext {\n    font-size: 12px;\n    color: #9BB7C4;\n}\n\n.start-game-btn {\n    height: 40px;\n    width: 100%;\n\n    border-radius: 8px;\n    background-color: #174B5F;\n    border: 1px solid #1F4E63;\n    color: #E6F2F7;\n\n    font-size: 14px;\n    font-weight: 600;\n\n    margin: 16px 0 12px 0;\n}\n\n.start-game-btn:hover {\n    background-color: #174B5F;\n    border-color: #3FA7C4;\n}\n\n.boards-screen {\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n\n    gap: 80px;\n}\n\n.board-wrapper {\n    position: relative;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    gap: 12px;\n}\n\n.board {\n    display: grid;\n    grid-template-columns: repeat(11, 48px);\n    grid-template-rows: repeat(11, 48px);\n}\n\n.board-cell {\n    border-right: 1px solid #2a6f89b3;\n    border-bottom: 1px solid #2a6f89b3;\n\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    position: relative;\n}\n\n.board-cell:has([class*='horizontal']) {\n    flex-direction: column;\n}\n\n.board-cell[data-col='0'] {\n    border-left: 1px solid #1F4E63;\n}\n\n.board-cell[data-col='9'] {\n    border-right: 1px solid #1F4E63;\n}\n\n.board-cell[data-row='9'] {\n    border-bottom: 1px solid #1F4E63;\n}\n\n.board-cell[data-row='0'] {\n    border-top: 1px solid #1F4E63;\n}\n\n.board-cell.no-border {\n    border: none;\n    align-self: center;\n}\n\n.board-label {\n    color: #7FA9B8;\n    font-size: 14px;\n    font-weight: 500;\n}\n\n.board-title {\n    font-size: 18px;\n    font-weight: 600;\n    color: #E6F2F7;\n}\n\n.ship-piece-sunk {\n    background-color: #2F3A40;\n    opacity: 70%;\n}\n\n.ship-piece,\n.ship-piece-sunk {\n    width: 48px;\n    height: 48px;\n    background-color: #4A6873;\n}\n\n.ship-piece-start-horizontal,\n.ship-piece-sunk-start-horizontal {\n    border-radius: 50% 0 0 50%;\n    height: 38px;\n    margin-left: 8px;\n    width: 40px;\n\n    border-top: 1px solid rgba(255, 255, 255, 0.25);\n    border-left: 1px solid rgba(255, 255, 255, 0.25);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.ship-piece-sunk-start-horizontal {\n    border-top: 2px solid #FF5A5A;\n    border-left: 2px solid #FF5A5A;\n    border-bottom: 2px solid #FF5A5A;\n}\n\n.ship-piece-middle-horizontal,\n.ship-piece-sunk-middle-horizontal {\n    height: 38px;\n    width: 48px;\n\n    border-top: 1px solid rgba(255, 255, 255, 0.25);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.ship-piece-sunk-middle-horizontal {\n    border-top: 2px solid #FF5A5A;\n    border-bottom: 2px solid #FF5A5A;\n}\n\n.ship-piece-finish-horizontal,\n.ship-piece-sunk-finish-horizontal {\n    border-radius: 0 50% 50% 0;\n    height: 38px;\n    margin-right: 8px;\n    width: 40px;\n\n    border-top: 1px solid rgba(255, 255, 255, 0.25);\n    border-right: 1px solid rgba(255, 255, 255, 0.25);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.ship-piece-sunk-finish-horizontal {\n    border-top: 2px solid #FF5A5A;\n    border-right: 2px solid #FF5A5A;\n    border-bottom: 2px solid #FF5A5A;\n}\n\n.ship-piece-start-vertical,\n.ship-piece-sunk-start-vertical {\n    border-radius: 50% 50% 0 0;\n    width: 38px;\n    margin-top: 8px;\n    height: 40px;\n\n    border-top: 1px solid rgba(255, 255, 255, 0.25);\n    border-left: 1px solid rgba(255, 255, 255, 0.25);\n    border-right: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.ship-piece-sunk-start-vertical {\n    border-top: 2px solid #FF5A5A;\n    border-left: 2px solid #FF5A5A;\n    border-right: 2px solid #FF5A5A;\n}\n\n.ship-piece-middle-vertical,\n.ship-piece-sunk-middle-vertical {\n    width: 38px;\n\n    border-left: 1px solid rgba(255, 255, 255, 0.25);\n    border-right: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.ship-piece-sunk-middle-vertical {\n    border-left: 2px solid #FF5A5A;\n    border-right: 2px solid #FF5A5A;\n}\n\n.ship-piece-finish-vertical,\n.ship-piece-sunk-finish-vertical {\n    border-radius: 0 0 50% 50%;\n    width: 38px;\n    margin-bottom: 8px;\n    height: 40px;\n\n    border-right: 1px solid rgba(255, 255, 255, 0.25);\n    border-left: 1px solid rgba(255, 255, 255, 0.25);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.ship-piece-sunk-finish-vertical {\n    border-bottom: 2px solid #FF5A5A;\n    border-left: 2px solid #FF5A5A;\n    border-right: 2px solid #FF5A5A;\n}\n\n.ship-piece-single-none,\n.ship-piece-sunk-single-none {\n    width: 28px;\n    height: 40px;\n    margin: 8px 0;\n\n    border: 1px solid rgba(255, 255, 255, 0.25);\n\n    border-radius: 75% / 30%;\n}\n\n.ship-piece-sunk-single-none {\n    border: 2px solid #FF5A5A;\n}\n\n.move-hit {\n    position: absolute;\n\n    width: 12px;\n    height: 12px;\n    background: #F05A5A;\n\n    border-radius: 50%;\n\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%) scale(1);\n\n    animation: hit-pulse 0.2s ease;\n}\n\n.move-hit::after {\n    content: '';\n    position: absolute;\n\n    inset: 0;\n    border: 2px solid #FF6B6B;\n    border-radius: 50%;\n\n    animation: hit-ring 0.35s ease-out;\n}\n\n.move-miss {\n    position: absolute;\n\n    width: 8px;\n    height: 8px;\n    background: #D8F1FF;\n\n    border-radius: 50%;\n\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n}\n\n.move-miss::after {\n    content: '';\n    position: absolute;\n\n    inset: 0;\n    border: 2px solid #A6D8F0;\n    border-radius: 50%;\n\n    animation: miss-ripple 0.4s ease-out;\n}\n\n.name {\n    font-weight: 500;\n    font-size: 16px;\n}\n\n#user-name {\n    color: #CFE4EC;\n}\n\n#comp-name {\n    color: rgba(207, 228, 236, 0.7);\n}\n\n.active-turn {\n    color: #4FC3E0;\n}\n\n.inactive-turn {\n    color: rgba(207, 228, 236, 0.5);\n}\n\n.player-board-buttons-wrapper {\n    display: flex;\n\n    gap: 12px;\n}\n\n#generate-ships-placement-btn {\n    background-color: #349BB5;\n    color: #FFFFFF;\n    height: 40px;\n    padding: 0 20px;\n    border-radius: 8px;\n\n    font-size: 14px;\n    font-weight: 500;\n\n    border: none;\n}\n\n#generate-ships-placement-btn:hover {\n    background-color: #3FA7C4;\n}\n\n#drag-and-drop-ships-btn {\n    background-color: transparent;\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    color: #CFE4EC;\n    height: 40px;\n    padding: 0 20px;\n    border-radius: 8px;\n}\n\n#drag-and-drop-ships-btn:hover {\n    border-color: rgba(255, 255, 255, 0.35);\n    background-color: rgba(255, 255, 255, 0.04);\n}\n\n.dialog {\n    width: 420px;\n    padding: 36px;\n    background-color: #11323F;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 12px;\n\n    box-shadow: 0 12px 40px rgba(0, 0, 0, 0.35);\n}\n\n.winner-announcement-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.result {\n    font-size: 26px;\n    font-weight: 600;\n    margin-bottom: 16px;\n}\n\n.result-subtext {\n    font-size: 14px;\n    color: rgba(207, 228, 236, 0.7);\n    margin-bottom: 24px;\n}\n\n.result.victory {\n    color: #5FD1EE;\n}\n\n.result.defeat {\n    color: #E04E4E;\n}\n\n.announcement-buttons-wrapper {\n    display: flex;\n    gap: 20px;\n    margin-top: 24px;\n}\n\n#play-again-btn {\n    height: 40px;\n    border-radius: 8px;\n    background-color: #46B5CF;\n    color: #FFFFFF;\n    font-weight: 500;\n    border: none;\n    padding: 0 24px\n}\n\n#play-again-btn:hover {\n    background-color: #4FC3E0;\n}\n\n#exit-btn {\n    height: 40px;\n    border-radius: 8px;\n    background-color: transparent;\n    border: 1px solid #4A8090;\n    color: #CFE4EC;\n    padding: 0 24px\n}\n\n#exit-btn:hover {\n    background-color: rgba(255, 255, 255, 0.05);\n}\n\n.drag-and-drop-ships-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    gap: 16px;\n\n    height: 120px;\n}\n\n.ship {\n    scale: 0.8;\n}\n\n.ship[data-direction='horizontal'] {\n    display: flex;\n}\n\n.ship[data-direction='vertical'] {\n    display: flex;\n    flex-direction: column;\n}\n\n.ship.inactive {\n    display: none;\n}\n\n.invalid-shake {\n    animation: shake 150ms ease;\n}\n\n.board-cell.invalid {\n    background: rgba(224, 78, 78, 0.25);\n    border: 1px solid #E04E4E;\n    animation: invalid-flash 150ms ease;\n}\n\n.resize {\n    height: auto;\n}\n\n.enabled {\n    pointer-events: auto;\n}\n\n.disabled {\n    pointer-events: none;\n}\n\n.is-player-ready {\n    position: absolute;\n    inset: 0;\n\n    background: rgba(5, 20, 25, 0.4);\n    backdrop-filter: blur(3px);\n    border-radius: inherit;\n    pointer-events: auto;\n\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    top: 10%;\n}\n\n.is-player-ready-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n\n    padding: 24px 26px;\n\n    width: 280px;\n\n    background-color: rgba(18, 52, 64, 0.96);\n    border: 1px solid rgba(120, 200, 220, 0.22);\n    border-radius: 10px;\n    box-shadow: 0 10px 26px rgba(0, 0, 0, 0.35);\n}\n\n.is-player-ready-wrapper:hover {\n    animation-play-state: paused;\n}\n\n#is-ready-title {\n    font-size: 16px;\n    font-weight: 600;\n    letter-spacing: 1px;\n    color: #6FD3E3;\n    text-align: center;\n}\n\n.is-ready-subtext {\n    font-size: 13px;\n    color: rgba(200, 230, 240, 0.7);\n    line-height: 1.4;\n    text-align: center;\n}\n\n.ready-subtext {\n    font-size: 14px;\n    color: rgba(220, 245, 255, 0.85);\n}\n\n#is-ready-button {\n    margin-top: 4px;\n    height: 38px;\n    padding: 0 20px;\n    font-size: 14px;\n    font-weight: 600;\n\n    background-color: #4FA3B8;\n    color: #FFFFFF;\n\n    border: none;\n    border-radius: 8px;\n}\n\n#is-ready-button:hover {\n    background-color: #569FB2;\n    box-shadow: 0 3px 10px rgba(80, 180, 200, 0.18);\n}\n\n#connection-form-dialog {\n    width: 460px;\n    padding: 24px 28px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.45);\n\n    opacity: 0;\n    transform: translateY(12px);\n    transition:\n        opacity 180ms ease,\n        transform 180ms ease;\n}\n\n#connection-form-dialog.open {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n.connection-header {\n    font-size: 20px;\n    font-weight: 600;\n    letter-spacing: 0.8px;\n    color: #5FD1EE;\n}\n\n.connection-subtext {\n    font-size: 14px;\n    color: rgba(207, 228, 236, 0.7);\n    line-height: 1.4;\n}\n\n.connection-wrapper {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.host-player-top-wrapper,\n.connection-top-wrapper,\n.connect-to-friend-form-top-wrapper {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n\n    width: 100%;\n}\n\n.close-btn {\n    position: absolute;\n    right: 12px;\n}\n\n.connection-btns-wrapper {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 24px;\n\n    margin-top: 16px;\n}\n\n#start-connection-btn {\n    height: 40px;\n    padding: 0 28px;\n    background-color: #46B5CF;\n    color: #E6F2F7;\n    border: none;\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n\n    white-space: nowrap;\n}\n\n#start-connection-btn:hover {\n    background-color: #4FC3E0;\n}\n\n#connect-to-friend-btn {\n    height: 40px;\n    padding: 0 28px;\n    background-color: transparent;\n    color: #CFE4EC;\n    border: 1px solid rgba(255, 255, 255, 0.4);\n    border-radius: 8px;\n    font-size: 14px;\n    font-weight: 500;\n\n    white-space: nowrap;\n}\n\n#connect-to-friend-btn:hover {\n    background-color: rgba(120, 200, 220, 0.08);\n    border: 1px solid rgba(120, 200, 220, 0.55);\n    color: #E6FAFF;\n}\n\n#connection-to-friend-btn:hover {\n    background-color: rgba(255, 255, 255, 0.05);\n}\n\n#copy-player-id-btn,\n.close-btn {\n    width: 32px;\n    height: 32px;\n    background-color: transparent;\n    border: none;\n}\n\n#copy-img,\n.img {\n    width: 22px;\n    height: 22px;\n    filter: invert(89%) sepia(8%) saturate(323%) hue-rotate(169deg) brightness(95%) contrast(92%);\n}\n\n#copy-player-id-btn:hover,\n.close-btn:hover {\n    background-color: rgba(255, 255, 255, 0.08);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 6px;\n}\n\n.copy-player-id-wrapper {\n    display: flex;\n    gap: 6px;\n\n    align-items: center;\n    justify-content: center;\n}\n\n.host-player-id-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n#host-player-title,\n.title {\n    font-size: 20px;\n    font-weight: 600;\n    color: #5FD1EE;\n    letter-spacing: 0.6px;\n}\n\n#host-player-subtext {\n    font-size: 13px;\n    color: rgba(207, 228, 236, 0.65);\n    margin-bottom: 10px;\n}\n\n#host-player-id {\n    font-size: 17px;\n    color: #F2FAFF;\n    letter-spacing: 0.7px;\n    word-break: break-all;\n    font-weight: 500;\n}\n\n.player-id-wrapper {\n    padding: 12px 14px;\n    background: rgba(0, 0, 0, 0.24);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 6px;\n}\n\n.copy-btn-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n}\n\n#id-copied-confirmation-text {\n    font-size: 12px;\n    color: #5FD1EE;\n}\n\n.connect-to-friend-title {\n    color: #6FD3E3;\n}\n\n#connect-friend-subtext {\n    font-size: 13px;\n    color: rgba(200, 230, 240, 0.7);\n}\n\n#friend-id {\n    margin-top: 8px;\n    text-align: center;\n}\n\n#set-connection-btn {\n    height: 44px;\n    padding: 0 26px;\n    font-size: 14px;\n    font-weight: 600;\n    border-radius: 10px;\n    background-color: #4FA3B8;\n    color: #E6F2F7;\n    border: none;\n    box-shadow: 0 2px 8px rgba(80, 180, 200, 0.15);\n    margin-top: 12px;\n}\n\n#set-connection-btn:hover {\n    background-color: #569FB2;\n    box-shadow: 0 4px 12px rgba(80, 180, 200, 0.18);\n}\n\n.connect-to-friend-form {\n    display: flex;\n    flex-direction: column;\n\n    align-items: center;\n    justify-content: center;\n\n    gap: 14px;\n}\n\n.connection-closed-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    gap: 14px;\n}\n\n#signal-lost-text {\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 1.5;\n    color: rgba(220, 245, 255, 0.85);\n    max-width: 360px;\n    text-align: center;\n}\n\n#ok-button {\n    height: 36px;\n    min-width: 90px;\n    padding: 0 18px;\n\n    font-size: 14px;\n    font-weight: 600;\n\n    background-color: #4FA3B8;\n    color: #FFFFFF;\n\n    border: none;\n    border-radius: 8px;\n}\n\n#ok-button:hover {\n    background-color: #569FB2;\n    box-shadow: 0 1px 4px rgba(80, 180, 200, 0.12);\n}\n\n#rematch-primary-line {\n    font-size: 16px;\n    font-weight: 500;\n    color: rgba(220, 245, 255, 0.85);\n    line-height: 1.4;\n}\n\n#rematch-secondary-line {\n    font-size: 15px;\n    font-weight: 400;\n    color: rgba(220, 245, 255, 0.65);\n    line-height: 1.4;\n}\n\n.play-again-text {\n    color: #6FD3E3;\n    font-weight: 600;\n}\n\nfooter {\n    padding: 24px 0;\n\n    font-size: 14px;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    color: rgba(255, 255, 255, 0.65);\n}\n\n.inactive {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
